import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IOption } from 'ng-select';
import { Interaction } from 'src/app/pages/interactions/interaction.model';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-image-map',
  templateUrl: './image-map.component.html',
  styleUrls: ['./image-map.component.scss']
})
export class ImageMapComponent implements OnInit {

  @ViewChild('imageMap') imageMap;
  @Input() interactions: Interaction[];
  @Input() imagePath: string;
  @Input() interactionsOnMap = [];
  @Output() intsOnMapComplete = new EventEmitter();

  interactionsSelect: Array<IOption> = [];
  selectedInteraction = null;
  pendingInt = null;
  showSelect = false;
  intsOnMap = [];
  environment = environment;

  constructor() { }

  ngOnInit(): void {
    this.intsOnMap = this.interactionsOnMap ? this.interactionsOnMap : [] ;
    console.log('this.intsOnMap', this.intsOnMap);
  }

  loadInteractions(): void {
    this.interactionsSelect = [];
    const interactionsSelect = this.interactions.filter(int => !this.intsOnMap.filter(i => i.id === int.id).length);
    if (interactionsSelect.length) {
      interactionsSelect.forEach(int => {
          this.interactionsSelect.push({
            value: int.id,
            label: int.title
          });
      });
    }
  }

  addInteractionInMap(event): void {
    if (this.intsOnMap.length < this.interactions.length) {
      this.showSelect = true;
      this.loadInteractions();
      const image = this.imageMap.nativeElement;
      const bounds = image.getBoundingClientRect();
      const x = event.pageX - bounds.left - image.offsetLeft;
      const y = event.pageY - bounds.top - document.documentElement.scrollTop - image.offsetTop;
      const respX = (x - 15) * 100 / image.width;
      const respy = (y - 15) * 100 / image.height;
      this.pendingInt = {
        coordinates: {
          x: respX + '%',
          y: respy + '%',
        },
        interactionType: 'interactions',
        pending: true
      };
      this.intsOnMap.push(this.pendingInt);
      this.isIntsOnMapComplete();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent): void {
    this.intsOnMap = this.intsOnMap.filter(i => !i.pending);
    this.pendingInt = null;
    this.showSelect = false;
    this.isIntsOnMapComplete();
  }

  onSelectInteraction(pendingInt): void {
    const int = this.interactions.find(i => i.id === this.selectedInteraction);
    pendingInt.id = this.selectedInteraction,
    pendingInt.nodeType = int.nodeType;
    pendingInt.title = int.title;
    pendingInt.pending = false;
    this.pendingInt = null;
    this.showSelect = false;
    this.selectedInteraction = null;
    this.isIntsOnMapComplete();
  }

  changeIntOnMap(int): void  {
    this.pendingInt =  this.intsOnMap.find(i => i.id === int.id);
    this.pendingInt.pending = true;
    this.pendingInt.nodeType = 'interactions';
    this.pendingInt.id = null;
    this.loadInteractions();
    this.showSelect = true;
    this.isIntsOnMapComplete();

  }

  deleteIntOnMap(int): void {
    this.intsOnMap = this.intsOnMap.filter(i => !i.pending);
    this.pendingInt = null;
    this.showSelect = false;
    this.isIntsOnMapComplete();
  }

  isIntsOnMapComplete(): void {
    if (this.intsOnMap.length >= 1 && this.intsOnMap.filter(i => i.pending).length === 0) {
      this.intsOnMapComplete.emit(this.intsOnMap);
    } else {
      this.intsOnMapComplete.emit({});
    }
  }

}
